import Markdown from 'react-markdown';

import styles from './LandingPageHero.module.css';

export type LandingPageHeroProps = {
  ctaSubText?: string[];
  ctaText: string;
  ctaUrl: string;
  currentPathWithRepub: string;
  h1Heading: string;
  introText: string;
};

export const LandingPageHero = ({
  ctaSubText,
  ctaText,
  ctaUrl,
  currentPathWithRepub,
  h1Heading,
  introText,
}: LandingPageHeroProps) => {
  const signupWidgetContainerElementId = ctaUrl;

  return (
    <section className={styles.hero}>
      <h1 className={styles.heading}>{h1Heading}</h1>
      <div className={styles.introText}>
        <Markdown>{introText}</Markdown>
      </div>
      <a className={styles.cta} href={`${currentPathWithRepub}${signupWidgetContainerElementId}`}>
        {ctaText}
      </a>
      {ctaSubText && ctaSubText.length > 0 && (
        <p className={styles.tags} data-testid="landing-page-hero-tags">
          {ctaSubText.join(' · ')}
        </p>
      )}
    </section>
  );
};
